/*
namespace $ {
	
	export type $shm_hitalama_app_yard_send_progress = {
		sent: number
		total: number
		ratio: number
		active: boolean
	}
	
	type $shm_hitalama_app_yard_send_queue_item = {
		land: string
		sent: number
		total: number
	}
	
	const queues = new WeakMap< $giper_baza_yard, WeakMap< $mol_rest_port, $shm_hitalama_app_yard_send_queue_item[] > >()
	const buffered = new WeakMap< $giper_baza_yard, WeakMap< $mol_rest_port, number > >()
	const done = new WeakMap< $giper_baza_yard, Map< string, $shm_hitalama_app_yard_send_progress > >()
	
	function map_port< Value >( store: WeakMap< $giper_baza_yard, WeakMap< $mol_rest_port, Value > >, yard: $giper_baza_yard ) {
		let map = store.get( yard )
		if( !map ) store.set( yard, map = new WeakMap )
		return map
	}
	
	function map_land( yard: $giper_baza_yard ) {
		let map = done.get( yard )
		if( !map ) done.set( yard, map = new Map )
		return map
	}
	
	function queue( yard: $giper_baza_yard, port: $mol_rest_port ) {
		const map = map_port( queues, yard )
		let queue = map.get( port )
		if( !queue ) map.set( port, queue = [] )
		return queue
	}
	
	function buffered_size( port: $mol_rest_port ) {
		const socket = ( port as any ).socket as WebSocket | undefined
		return socket?.bufferedAmount ?? 0
	}
	
	function progress_apply( yard: $giper_baza_yard, port: $mol_rest_port, sent: number ) {
		if( sent <= 0 ) return
		
		const items = queue( yard, port )
		
		while( sent > 0 ) {
			const item = items[0]
			if( !item ) break
			
			const chunk = Math.min( sent, item.total - item.sent )
			item.sent += chunk
			sent -= chunk
			
			if( item.sent < item.total ) break
			
			items.shift()
			map_land( yard ).set( item.land, {
				sent: item.total,
				total: item.total,
				ratio: 1,
				active: false,
			} )
		}
	}
	
	function progress_refresh( yard: $giper_baza_yard, port: $mol_rest_port ) {
		const map = map_port( buffered, yard )
		const current = buffered_size( port )
		const prev = map.get( port ) ?? current
		
		if( current < prev ) progress_apply( yard, port, prev - current )
		map.set( port, current )
	}
	
	function send_bin_land(
		yard: $giper_baza_yard,
		port: $mol_rest_port,
		land: $giper_baza_link,
		data: Uint8Array< ArrayBuffer >,
	) {
		progress_refresh( yard, port )
		
		const before = buffered_size( port )
		queue( yard, port ).push({
			land: land.str,
			sent: 0,
			total: data.byteLength,
		})
		
		port.send_bin( data )
		
		const after = buffered_size( port )
		map_port( buffered, yard ).set( port, after )
		progress_apply( yard, port, Math.max( 0, before + data.byteLength - after ) )
	}
	
	;( $giper_baza_yard.prototype as any ).send_progress_land = function(
		this: $giper_baza_yard,
		land: $giper_baza_link,
		watch = true,
	) {
		let sent = 0
		let total = 0
		
		for( const port of this.ports() ) {
			progress_refresh( this, port )
			
			for( const item of queue( this, port ) ) {
				if( item.land !== land.str ) continue
				sent += item.sent
				total += item.total
			}
		}
		
		if( total ) {
			if( watch ) this.$.$mol_state_time.now( 250 )
			return {
				sent,
				total,
				ratio: sent / total,
				active: true,
			} as $shm_hitalama_app_yard_send_progress
		}
		
		const last = map_land( this ).get( land.str )
		if( last ) return last
		
		if( watch ) this.$.$mol_state_time.now( 250 )
		return null
	}
	
	;( $giper_baza_yard.prototype as any ).sync_port_land = function sync_port_land(
		this: $giper_baza_yard,
		[ port, land ]: [ $mol_rest_port, $giper_baza_link ],
	) {
		
		try {
			
			this.init_port_land([ port, land ])
			
			const faces = this.face_port_land([ port, land ])
			if( !faces ) return
			
			const Land = this.$.$giper_baza_glob.Land( land )
			Land.units_saving()
			
			const part = Land.diff_part( faces )
			if( !part.units.length ) return
			
			if( this.$.$giper_baza_log() ) this.$.$mol_log3_rise({
				place: this,
				message: 'Send Unit',
				port: $mol_key( port ),
				land: Land,
				part,
			})
			
			const pack = $giper_baza_pack.make([[ Land.link().str, part ]])
			
			send_bin_land( this, port, Land.link(), pack.asArray() )
			faces.sync( part.faces )
			
		} catch( error ) {
			$mol_fail_log( error )
		}
		
	}
	
	$mol_mem_key( $giper_baza_yard.prototype, 'sync_port_land' )
	
}
*/
